import { useState, useCallback } from 'react';
import type { ChildrenQueryData, ExpandedItems } from '@atlassian/jira-business-list-handlers';
import type { IssueId } from '@atlassian/jira-shared-types';
import type { TimelineViewIssuesReturn } from '../../services/get-timeline-view-issues/types';

export const useHierarchy = () => {
	const [childrenQueryData, setChildrenQuery] = useState<
		ChildrenQueryData<TimelineViewIssuesReturn>
	>({});
	const [expandedItems, setExpandedItems] = useState<ExpandedItems>({});

	const setChildrenQueryData = useCallback((issueId: string, newData: TimelineViewIssuesReturn) => {
		setChildrenQuery(
			(
				prevState: ChildrenQueryData<TimelineViewIssuesReturn>,
			): ChildrenQueryData<TimelineViewIssuesReturn> => ({
				...prevState,
				[issueId]: newData,
			}),
		);
	}, []);

	const setIssueExpanded = useCallback((issueId: IssueId, isExpanded: boolean) => {
		setExpandedItems((prevState) => ({
			...prevState,
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			[issueId as string]: isExpanded,
		}));
	}, []);

	return {
		childrenQueryData,
		expandedItems,
		setChildrenQueryData,
		setIssueExpanded,
	};
};
